




























import Vue from 'vue';
import { Icon, Toast } from '@descomplica/vue-components';
import CourseModal from './modals/CourseModal.vue';
import CampusModal from './modals/CampusModal.vue';

interface Data {
  courseModalActive: boolean;
  campusModalActive: boolean;
  errorMessageLabel: string;
}

export default Vue.extend({
  components: { Icon, CourseModal, CampusModal, Toast },
  data(): Data {
    return {
      courseModalActive: false,
      campusModalActive: false,
      errorMessageLabel: '',
    };
  },
  computed: {
    courseName(): string {
      return this.$store.getters.courseName ?? '';
    },
    campusTitle(): string {
      const { campus } = this.$store.getters;
      if (!campus) return '';
      return `${campus?.name}, ${campus?.city} - ${campus?.state}`;
    },
    canChangeCourseCampus(): boolean {
      const academicRecord = this.$store.getters.backofficeStudentAcademicRecord ?? null;
      const isJacadCourse = this.$store.getters.isJacadCourse === true;
      return !academicRecord && !isJacadCourse;
    },
  },
  methods: {
    closeCourseModal() {
      this.courseModalActive = false;
    },
    openCourseModal() {
      this.courseModalActive = true;
    },
    closeCampusModal() {
      this.campusModalActive = false;
    },
    openCampusModal() {
      this.campusModalActive = true;
    },
    triggerError(errorMessageLabel: string) {
      this.errorMessageLabel = errorMessageLabel;

      setTimeout(() => {
        this.errorMessageLabel = '';
      }, 3000);
    },
  },
});
